/**
 * Implements the main hamburger button as a behavior.
 *
 * It must attached to the main layout.
 */

import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
import { getTransitionEvent } from "../utils";

const channel = Radio.channel("global");

const TARGET_EL = "#side-menu";
const TOGGLE_CLASSNAME = "expanded";
const HIDDEN_CLASSNAME = "hidden";

class HamburgerBehaviors extends Marionette.Behavior {
  ui() {
    return {
      menu: ".menu",
    };
  }

  events() {
    return {
      "click @ui.menu": "_onClick",
    };
  }

  _onClick(e) {
    e.preventDefault();
    $("body").toggleClass(TOGGLE_CLASSNAME);
  }

  onRender() {
    const $el = $(TARGET_EL);
    // track transition completion of tracked region when it is collapsed
    const transitionEvent = getTransitionEvent($el[0]);
    if (transitionEvent) {
      this.$el.delegate(
        TARGET_EL,
        transitionEvent,
        this._onTransitionEnd.bind(this)
      );
    }

    // enable button
    this.ui.menu.removeClass(HIDDEN_CLASSNAME);
  }

  _onTransitionEnd() {
    channel.trigger("content-resized");
  }
}

export { HamburgerBehaviors as default };
